import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import LandingService from 'components/_landing';
import { GetMain } from 'api/site'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

var index = function index(_ref) {
  var main = _ref.main;
  return /*#__PURE__*/_jsx(LandingService, {
    data: main
  });
};

index.getInitialProps = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var main;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return GetMain();

        case 2:
          main = _context.sent;
          return _context.abrupt("return", {
            main: main.data
          });

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));
export default index;